"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserFormTabs = void 0;
var React = require("react");
var react_tabs_1 = require("react-tabs");
require("react-tabs/style/react-tabs.css");
var UserDataForm_1 = require("./UserDataForm");
// DISABLE false cos they are not use at the moment.
var UserFormTabs = /** @class */ (function (_super) {
    __extends(UserFormTabs, _super);
    function UserFormTabs(props) {
        return _super.call(this, props) || this;
    }
    UserFormTabs.prototype.render = function () {
        var _this = this;
        return (React.createElement(react_tabs_1.Tabs, null,
            React.createElement(react_tabs_1.TabList, null,
                React.createElement(react_tabs_1.Tab, null, "Gebrulker gegevens")),
            React.createElement(react_tabs_1.TabPanel, null,
                React.createElement(UserDataForm_1.default, { user: this.props.selectedUser, updateUser: function (user) { return _this.props.updateUser(user); }, isSuperAdmin: this.props.isSuperAdmin, canGrantGpsProposal: this.props.canGrantGpsProposal, checkEmailExists: this.props.checkEmailExists, currentUserCompanyIds: this.props.currentUserCompanyIds }))));
    };
    return UserFormTabs;
}(React.Component));
exports.UserFormTabs = UserFormTabs;
